<template>
  <div
    v-if="context.request.country.is_russia && !context.request.user.is_authenticated"
    class="d-flex justify-end align-center"
  >
    <!-- eslint-disable vue/no-template-target-blank -->
    <a
      target="_blank"
      class="text-body-1 text-secondary--text text-decoration-none mr-8"
      :href="siteNameExpert"
    >
      {{ translate('Клиникам') }}
    </a>
    <a
      target="_blank"
      class="text-body-1 text-secondary--text text-decoration-none"
      :href="`${siteNameExpert}vrachu/`"
    >
      {{ translate('Врачам') }}
    </a>
  </div>
</template>

<script setup lang="ts">
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore } from 'src/store'
import { translate } from 'src/layouts/core-layout/_functions/translate'

const { context }: ContextStore = useContextStore()
const { siteNameExpert } = context.global.sites
</script>
